import React from 'react'
import {isProduction} from '@utils'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {AnalyticsModuleIcon, CircleIcon} from '@csrc/assets/icons'

export const analyticsNavigation = [
	{
		id: 'wb.analytics',
		title: 'analytics.nav.analytics',
		icon: <FontAwesomeIcon icon={AnalyticsModuleIcon}/>,
		children:[
			{
				id: 'wb.analytics.overview',
				title: 'analytics.nav.overview',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/analytics/overview',
				action: 'call',
				resource: 'ANA_OVERVIEW_STATISTICS',
				featureKey: 'ana_overview'
				// omit: isProduction()
			},
			{
				id: 'wb.analytics.issues',
				title: 'analytics.nav.issues',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/analytics/issues',
				action: 'call',
				resource: 'ANA_ISSUES_STATISTICS',
				featureKey: 'ana_issues'
				// omit: isProduction()
			},
			{
				id: 'wb.analytics.responses',
				title: 'analytics.nav.responses',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/analytics/responses',
				action: 'call',
				resource: 'ANA_RESPONSES_STATISTICS',
				featureKey: 'ana_responses'
				// omit: isProduction()
			},
			{
				id: 'wb.analytics.inspections',
				title: 'analytics.nav.inspections',
				icon: <FontAwesomeIcon icon={CircleIcon}/>,
				navLink: '/analytics/reports',
				action: 'call',
				resource: 'ANA_REPORTS_STATISTICS',
				featureKey: 'ana_reports'
				// omit: isProduction()
			}
		]
	}
]
